<template>
    <div >
        <div class="report-titlebar" :style="{ paddingTop: titlePadding + 'px', 'background-color': 'white', 'position': 'fixed', 'width': '100%'}">
                <img @click="$router.go(-1)" class="message-icon_back" src="@/assets/instantMessaging/ic_back.svg"/>
                <span class="message-title">举报</span>
        </div>
        <div class="page-box">
            <div class="page-inner">
                <p class="type">
                    请选择举报该聊天的类型
                    <span>*</span>
                </p>
                <div class="type-row" v-for="(item, index) in reportTypeList" :key="index">
                    <div @click="selectHandle(item2)" v-for="(item2, index) in item" :key="index" class="row-item" :class="{'item-active': item2.select}">{{ item2.name }}</div>
                </div>
                <p class="describe">举报描述</p>
                <!-- <textarea
                    v-model="content"
                    class="textarea"
                    placeholder="请输入举报详细描述"
                    cols="30"
                    rows="10"
                    maxlength="500"></textarea>
                <div class="tip">{{ content.length }}/500</div> -->

                <van-field
                    class="mytextarea"
                    v-model="content"
                    rows="2"
                    type="textarea"
                    maxlength="500"
                    placeholder="请输入举报详细描述"
                    show-word-limit
                    />


                <p class="img-describe">图片证据 <span>(最多3张)</span></p>

                <upload class="my-upload" @fileuploadData="fileUploadData" />
            </div>

        </div>
        <div :style="{'bottom': openKeyboard ? `0px` : `54px`}" @click="submit" class="foot-button">
            <div>确定</div>
        </div>
    </div>
</template>

<script>
import titleBar from '../../components/titleBar.vue'
import { mapGetters, mapState } from 'vuex';
import upload from '../../components/upload.vue'
import api from '../../../../service/modules/instantMessaging'

export default {
    components: { upload, titleBar },
    computed: {
            ...mapGetters('instantMessaging', [
            ]),
            ...mapState('instantMessaging', [
                'currentConversation'
            ]),
		},
    data() {
        return {
            titlePadding: 40,
            reportTypeList: [
                [{name: '反动言论', select: false, type: 1}, {name: '不友善内容', select: false, type: 2},],
                [{name: '违法违规', select: false, type: 3}, {name: '色情低俗', select: false, type: 4},],
                [{name: '广告内容', select: false, type: 5}, {name: '其他', select: false, type: 0},],
            ],
            content: '',
            // Imglist: [],
            fileUrl: [],
            docmHeight: window.innerHeight,  //默认屏幕高度
            showHeight: window.innerHeight,   //实时屏幕高度
            openKeyboard: false
        }
    },
    created() {
		this.setTitlePadding();

    },
    mounted() {
        window.onresize = ()=>{
            return(()=>{
                this.showHeight = window.innerHeight;
            })()
        }
    },
    watch: {
        showHeight: function(newValue) {
            if(this.docmHeight > newValue){
                this.openKeyboard = true
            }else{
                this.openKeyboard = false
            }
        }
    },
    methods: {
        setTitlePadding() {
            let u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isiOS) {
                this.titlePadding = 30;
            }
        },
      fileUploadData (Imglist) {
          this.fileUrl = Imglist
      },
      // 点击类型事件
      selectHandle(item) {
        item.select = !item.select
        this.reportTypeList.map(i => {
            i.map(i2 => {
              (i2.type !== item.type) && (i2.select = false)
            })
        })
      },
        submit() {
            let typeList = []
            this.reportTypeList.map(i => {
                i.map(i2 => {
                    i2.select && typeList.push(i2.type)
                })
            })
            if (typeList.length === 0) {
                return this.$Toast({
                    message: '请选择举报类型'
                });
            }
            let chatName
            if (!this.currentConversation || !this.currentConversation.groupProfile) {
	            chatName = '退货服务窗';
	          } else {
              chatName = `「${this.currentConversation.groupProfile.name}」退货服务窗`
            }
            const param = {
              chatId: this.currentConversation.conversationID, // 因为退货都是群聊，所以不用判断是群聊还是单聊，直接传回话id
              chatName,
              description: this.content,
              type: typeList.join(','),
              imgList: this.fileUrl.splice(0, 3) // 预防在选择图片的时候选择多张，在这里只取前三张
            }
            api.report(param).then(res => {
              if (res.ret === 0) {
                this.$Toast({
                    message: '感谢您的反馈，一部手机管旅游平台会及时核实您的举报并处理。',
                    duration: 3000
                });
                setTimeout(() => {
                  this.$router.back()
                }, 3000)
              }
            })

        }
    }
}
</script>

<style lang="less">
    .report-titlebar {
        position: relative;
       height: 44px;
        width: 100%;
        /*padding: 0 12px 0 16px;*/
        display: flex;
        align-items: center;
        // background-color: #36B374;
        /* 适配齐刘海*/
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        box-sizing: content-box;
        justify-content: space-around;
        // color: white;
        font-size: 16px;
        .message-icon_back {
            position: absolute;
            width: 16px;
            height: 16px;
            // top: 50%;
            // transform: translateY(-50%);
            left: 12px;
        }
    }
    .page-box {
        padding: 70px 16px 0;
        // min-height: 100vh;
        background: rgba(245, 246, 249, 0.39);
        .page-inner {
            background-color: white;
            padding: 16px;
            padding-bottom: 50px;
            // min-height: 100vh;

            .type {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #000000;
                margin-bottom: 16px;
                span {
                    color: red;
                }
            }
            .type-row {
                display: flex;
                justify-content: space-between;
                margin-bottom: 12px;

                .row-item {
                    flex: 1;
                    text-align: center;
                    border-radius: 2px;
                    padding: 8px 0;
                    border: 1px solid #E6E6E6;
                    font-weight: 400;
                    line-height: 20px;
                    color: #999999;

                    &:first-child {
                        margin-right: 12px;
                    }
                }

                .item-active {
                    border: 1px solid #36B374;
                    color: #36B374;
                }
            }

            .describe {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 22px;
                color: #171A1D;
                margin-top: 16px;
                margin-bottom: 12px;
            }

            .img-describe {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 22px;
                color: #171A1D;
                margin-bottom: 12px;
                span {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 20px;
                    color: #999999;
                }
            }

            /deep/.mytextarea {
                background-color: #F9FAFC;
                margin-bottom: 18px;
                .van-field__control {
                    height: 190px;
                }
                .van-field__word-limit {
                    color: #CCCCCC;
                    font-size: 12px;
                }
            }
            /deep/.my-upload {
              .title {
                visibility: hidden;
              }
            }
            .textarea {
                width: 100%;
                height: 160px;
                background: #f8f9fb;
                padding: 16px;
                border-radius: 4px;
                border: 0;
                font-size: 14px;
                line-height: 20px;
                box-sizing: border-box;
                }
                .tip {
                text-align: right;
                padding-right: 16px;
                background: #f8f9fb;
                width: 100%;
                position: relative;
                top: -15px;
                font-size: 14px;
                color: #cccccc;
                border-radius: 0 0 4px 4px;
                padding-bottom: 16px;
                }
        }
    }
    .foot-button {
        position: fixed;
        // bottom: 54px;
        height: 48px;
        border-radius: 3px;
        line-height: 48px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        width: 100vw;
        padding: 0 16px;
        div {
            background-color: #36B374;
        }
        
    }
</style>